














































import { computed, ComputedRef, defineComponent, WritableComputedRef } from "@vue/composition-api"
import { useActions, useGetters } from "vuex-composition-helpers"
import { Contact } from "@/apps/StudentExchangeNonPartnerWidget/models/store-viewmodel"
import { ContactValue } from "@/apps/StudentExchangeNonPartnerWidget/models/contact-enums"
import ExchangeCard from "@/shared/components/molecules/ExchangeCardMolecule.vue"
import InputAtom from "@/shared/components/atoms/InputAtom.vue"
import ErrorMessage from "@/shared/components/atoms/ErrorMessageAtom.vue"

export default defineComponent({
    name: "ExchangeContact",
    components: { ErrorMessage, ExchangeCard, InputAtom },
    setup() {
        const {
            getLabels, 
            getContact,
            isEditable,
            getContactIsInvalid
        } = useGetters([
            'getLabels', 
            'getContact',
            'isEditable',
            'getContactIsInvalid'
        ])
        const {
            setContact
        } = useActions([
            'setContact'
        ])

        const contact: WritableComputedRef<Contact> = computed({
            get(): Contact {
                return getContact.value
            },
            set(value: Contact): void {
                setContact(value)
            }
        })

        const disabled: ComputedRef<boolean> = computed(() => !isEditable.value)
        const contactIsInvalid: ComputedRef<boolean> = computed(() => getContactIsInvalid.value)

        function handleInput(type: ContactValue, value: any) {
            switch (type) {
                case ContactValue.NAME:
                    contact.value = {
                        completed: false,
                        name: value,
                        email: contact.value.email
                    }
                    break
                case ContactValue.EMAIL:
                    contact.value = {
                        completed: false,
                        name: contact.value.name,
                        email: value
                    }
                    break
            }
        }

        return {
            contact,
            disabled,
            handleInput,
            ContactValue,
            getLabels,
            contactIsInvalid
        }
    }
})
